import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SchemaType } from '../../templates/form';

export type TemplateColorType = {
  colorId: string;
  colorValue: string;
  colorLabel: string;
}[];
export type TemplateMetaConfigType = {
  externalLink: boolean;
  linkRel: string;
  schemaEnabled: boolean;
};
// Export This Type; Else createStore throws some nasty errors
export interface ConfigurationState {
  global: {
    config: TemplateMetaConfigType;
    colors: TemplateColorType;
    enableGlobalColors: boolean;
  };
  template: {
    [K in keyof SchemaType]: {
      [key: string]: {
        colors?: TemplateColorType;
        extraConfig?: Record<string, unknown>;
      };
    };
  };
}

const localStoreState = JSON.parse(
  localStorage.getItem('tk-template-store') || '{}'
);

const initialState: ConfigurationState =
  (localStoreState.configuration as ConfigurationState) || {
    global: {
      colors: [],
      config: {
        externalLink: true,
        linkRel: 'nofollow',
        schemaEnabled: false,
      },
      enableGlobalColors: false,
    },
    template: {
      comparison: {},
      showcase: {},
      slim: {},
      list: {},
      table: {},
    },
  };

export const configurationSlice = createSlice({
  name: 'configuration',
  initialState,
  reducers: {
    initThemeConfig: (
      state,
      action: PayloadAction<{
        colors: TemplateColorType;
        type: keyof SchemaType;
        template: string;
      }>
    ) => {
      const { colors, template, type } = action.payload;
      if (state.template[type]) {
        state.template[type][template] = { colors };
      } else {
        state.template[type] = {
          [template]: { colors },
        };
      }
    },

    updateColor: (
      state,
      action: PayloadAction<{
        colorId: string;
        colorValue: string;
        template?: string;
        type?: keyof SchemaType;
      }>
    ) => {
      const { colorId, colorValue, template, type } = action.payload;
      if (template && type) {
        const { colors } = state.template[type][template];

        const newColors = colors?.map((color) => {
          if (color.colorId === colorId) {
            return { ...color, colorValue };
          }
          return color;
        });

        state.template[type][template].colors = newColors;
      } else {
        state.global.colors = {
          ...state.global.colors,
          [colorId]: colorValue,
        };
      }
    },
    updateConfig: (
      state,
      action: PayloadAction<{
        configKey: keyof TemplateMetaConfigType;
        value: boolean | string | undefined;
      }>
    ) => {
      const { configKey, value } = action.payload;
      // @ts-ignore
      state.global.config[configKey] = value;
    },
  },
});

export const { updateColor, updateConfig, initThemeConfig } =
  configurationSlice.actions;

export default configurationSlice.reducer;
